import {ActionReducer} from '@ngrx/store';
import {localStorageSync} from 'ngrx-store-localstorage';

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
    return (state, action) => {
        if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
            // Only apply localStorage sync in browser environments
            return localStorageSync({
                keys: ['storage', 'user'], // Specify state slices to store in localStorage
                rehydrate: true, // Rehydrate state from localStorage on app load
            })(reducer)(state, action);
        }

        // Return the reducer without modification for SSR
        return reducer(state, action);
    };
}

